import { useTipTapEditorContext } from "@circle-react-uikit/TipTap/TipTapEditorContext";
import { useBlockEditorContext } from "@circle-react-uikit/TipTapBlockEditor/BlockEditorContext";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useEffect, useRef } from "react";
import { useQuery } from "react-query";

interface Props {
  command: (item: any) => void;
  href: string;
  isSpacesOnly?: boolean;
}

interface UnfurlEntityLink {
  sgid: string;
  type: string;
}

export const EntityPaste = ({
  href,
  command,
  isSpacesOnly = false,
}: Props): any => {
  const tiptapEditorContext = useTipTapEditorContext();
  const tiptapBlockEditorContext = useBlockEditorContext();
  const { addToLocalSgidToObjectMap } =
    tiptapEditorContext || tiptapBlockEditorContext;

  const processedSgidRef = useRef<string | null>(null);
  const { data = [] } = useQuery<UnfurlEntityLink[]>({
    queryKey: [
      internalApi.richTextFields.unfurlURLs({
        params: { urls: [href] },
      }),
    ],
    initialData: [],
  });

  useEffect(() => {
    const entityLink = data[0];

    if (!entityLink?.type || entityLink.type === "message") return;
    if (isSpacesOnly && entityLink.type !== "space") return;
    if (processedSgidRef.current === entityLink.sgid) return;

    let isCancelled = false;

    queueMicrotask(() => {
      if (isCancelled) return;

      processedSgidRef.current = entityLink.sgid;
      addToLocalSgidToObjectMap({
        sgid: entityLink.sgid,
        object: entityLink,
      });
      command(entityLink.sgid);
    });

    return () => {
      isCancelled = true;
    };
  }, [addToLocalSgidToObjectMap, command, data, isSpacesOnly]);

  return null;
};

EntityPaste.displayName = "EntityPaste";
